<mat-dialog-content class="dialog-content">
        <ng-container *ngComponentOutlet="data.component"></ng-container>
</mat-dialog-content>